import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ManagePufferPage } from './manage-puffer.page';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DirectiveModule } from '../../directive/directive.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule
  ],
  declarations: [ManagePufferPage],
  entryComponents: [ManagePufferPage]
})
export class ManagePufferPageModule {}
